<div class="modal-header">
  <div class="modal-header__title">{{ title | translate }}</div>
  <button
    type="button"
    class="closeModal"
    (click)="dismiss()"
    data-dismiss="modal"
    aria-label="Close">
    <span aria-hidden="true">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect
          width="20"
          height="2"
          rx="1"
          transform="matrix(-0.707107 0.707107 0.707107 0.707107 16.3643 2.22266)"
          fill="#1195FF" />
        <rect
          x="3.63574"
          y="2.22266"
          width="20"
          height="2"
          rx="1"
          transform="rotate(45 3.63574 2.22266)"
          fill="#1195FF" />
      </svg>
    </span>
  </button>
</div>
<div class="modal-body">
  <div class="container">
    <div class="row">
      <div class="container">
        <app-add-additional-document-form
          [docType]="docType"
          [onNextStep]="onNextStep"
          (formSubmitted)="save($event)"
          (hostedCurrentStep)="changeButtons($event)"
          (formIsValid)="unlockButton($event)"
          #form></app-add-additional-document-form>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <lib-mt-button-big
    class="close"
    [callToAction]="'C_A_CANCEL' | translate"
    [color]="'secondary'"
    (Click)="dismiss()"></lib-mt-button-big>
  <lib-mt-button-big
    *ngIf="!isNextStep"
    class="save"
    [callToAction]="'C_A_SAVE' | translate"
    [disabled]="flag"
    [color]="'primary'"
    [loading]="loading"
    (Click)="form.submit()"></lib-mt-button-big>
  <lib-mt-button-big
    *ngIf="isNextStep"
    class="save"
    [callToAction]="'M_PAC_ENROLLMENT_SMILE_ACCOUNT_NEXT_STEP' | translate"
    [disabled]="flag"
    [color]="'primary'"
    [loading]="loading"
    (Click)="nextStep()"></lib-mt-button-big>
</div>
